export enum StorageEnum {
  TABLE_SETTINGS = 'tableSettings',
}
